// utils/callApi.ts
import axios from "axios";
import { TOKEN, ORGANIZATION_ID, USER_ID, WORKSPACE_ID } from "../../constants/enums";

const CORE_API = process.env.REACT_APP_CORE_API || "https://prod-api.indxx.com";

export default async function callApi3(
  endpoint: string,
  method: "post" | "get" = "post",
  body?: any,
  customHeaders?: Record<string, string>
) {
  let authUser = window.localStorage.getItem(TOKEN);

  let headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (authUser) {
    try {
      const token = JSON.parse(authUser);
      if (token && token !== "") {
        headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // fail silently
    }
  }

  headers = { ...headers, ...customHeaders };

  try {
    const response = await axios({
      url: `${CORE_API}/api/${endpoint}`,
      method,
      data: body,
      headers,
    });

    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      window.localStorage.removeItem(TOKEN);
      window.localStorage.removeItem(ORGANIZATION_ID);
      window.localStorage.removeItem(USER_ID);
      window.localStorage.removeItem(WORKSPACE_ID);
      window.location.href = "/login";
    } else {
      throw error;
    }
  }
}
